import { useCallback, useEffect, useState } from "react";
import { useAuth } from "./AuthProvider";
import { StaticLoadingScreen } from "../shared/LoadingScreen";
import StaticErrorScreen from "../shared/error/StaticErrorScreen";
import { captureException } from "@sentry/browser";
import { Redirect, useLocation } from "react-router";
import { TextLink } from "@teamscheme/text-link";
import { ApiError } from "../api/ApiClient";

export function LogoutCallbackPage() {
  const location = useLocation();
  const returnTo = new URLSearchParams(location.search).get("returnTo");
  if (returnTo) return <Redirect to={returnTo} />;
  return <Redirect to="/" />;
}

export default function LoginCallbackPage() {
  const [error, setError] = useState<Error | null>(null);

  const auth0Context = useAuth();

  const { handleRedirectCallback } = auth0Context;

  const onHandle = useCallback(
    async function () {
      if (handleRedirectCallback) {
        try {
          await handleRedirectCallback();
        } catch (error) {
          captureException(error);
          setError(error as ApiError);
        }
      }
    },
    [handleRedirectCallback]
  );

  useEffect(() => {
    onHandle();
  }, [onHandle]);

  if (error) {
    return (
      <StaticErrorScreen
        message={
          <span>
            Denne sesjonen har utløpt. Prøv på nytt eller{" "}
            <TextLink linkTo="/">gå tilbake til landingssiden</TextLink>.
          </span>
        }
      />
    );
  }

  return <StaticLoadingScreen />;
}
